import React from "react";
import cx from "classnames";
import { useId } from "@jutro/platform";
import { useTranslator } from "@jutro/locale";
import styles from "./BrandedLoader.module.css";
import { messages } from "./BrandedLoader.messages";
export var BrandedLoader = function () {
  var translator = useTranslator(),
    id = useId();
  return React.createElement(React.Fragment, null, React.createElement("div", {
    "data-testid": "branded-loader",
    className: styles.brandedLoader,
    "aria-describedby": id
  }, React.createElement("svg", {
    viewBox: "0 0 90 90"
  }, React.createElement("g", null, React.createElement("polygon", {
    className: cx(styles.fill1, styles.logoSegment),
    points: "0,0 30,0 30,30 0,30"
  }), React.createElement("polygon", {
    className: cx(styles.fill3, styles.logoSegment),
    points: "30,0 60,0 60,30 30,30"
  }), React.createElement("polygon", {
    className: cx(styles.fill2, styles.logoSegment),
    points: "60,0 90,0 90,30 60,30"
  }), React.createElement("polygon", {
    className: cx(styles.fill5, styles.logoSegment),
    points: "0,30 30,30 30,60 0,60"
  }), React.createElement("polygon", {
    className: cx(styles.fill4, styles.logoSegment),
    points: "30,30 60,30 60,60 30,60"
  }), React.createElement("polygon", {
    className: cx(styles.fill7, styles.logoSegment),
    points: "60,30 90,30 90,60 60,60"
  }), React.createElement("polygon", {
    className: cx(styles.fill6, styles.logoSegment),
    points: "0,60 30,60 30,90 0,90"
  }), React.createElement("polygon", {
    className: cx(styles.fill8, styles.logoSegment),
    points: "30,60 60,60 60,90 30,90"
  }), React.createElement("polygon", {
    className: cx(styles.fill4, styles.logoSegment),
    points: "60,60 90,60 90,90 60,90"
  })))), React.createElement("div", {
    id: id,
    className: styles.screenReaderOnly
  }, translator(messages.loading)));
};
BrandedLoader.displayName = "BrandedLoader", BrandedLoader.__docgenInfo = {
  description: "BrandedLoader is default loader element for Loader component",
  methods: [],
  displayName: "BrandedLoader"
}, BrandedLoader.__docgenInfo = {
  componentName: "BrandedLoader",
  packageName: "@jutro/components",
  description: "BrandedLoader is default loader element for Loader component",
  displayName: "BrandedLoader",
  methods: [],
  actualName: "BrandedLoader"
};